import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchPartnerConnectStatus } from '@/lib/api';

export function usePartnerConnectStatus(agentId: string | null, enabled = true) {
  const [returning] = useState(() => typeof window !== 'undefined' && ['success', 'refresh'].includes(new URLSearchParams(window.location.search).get('connect') ?? ''));
  return useQuery({ queryKey: ['partner-connect-status', agentId, returning],
    queryFn: () => fetchPartnerConnectStatus(agentId!, returning), enabled: enabled && !!agentId,
    staleTime: 30_000, refetchOnMount: 'always', refetchInterval: 30_000, retry: false });
}
